import { useEffect } from 'react';
import useMount from '@src/utils/hooks/use-mount';
import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import Video from '@src/components/video';
import AntdMessage from '@src/components/antd/message';
import $$tracker from '@src/tracker';
import CdkModal from '@src/business-components/cdk-modal';
import CdkModalStore from '@src/business-components/cdk-modal/store';
import SuccessModal from '@src/business-components/success-modal';
import SuccessModalStore from '@src/business-components/success-modal/store';
import useModal from '@src/utils/hooks/use-modal';
import { replaceDownloadLinkPc, replaceDownloadLinkAndroid } from '@src/utils/replace_download_link_by_source';

class KvSectionStore extends BaseStore {
  constructor(options = {}) {
    super();
    Object.assign(this, options);
  }

  @observable mainStore;

  @observable isActive = false;

  // PV视频播放状态
  @observable videoPlayState = false;

  // 进入KV播放前的背景音乐状态
  @observable bgmWasPlayingBeforePv = false;

  // 官方网站链接
  @observable officialUrl = 'https://www.cbjq.com/index/index.html';

  // PV视频链接
  @observable pvVideoUrl = '';

  //首页左侧礼包按钮状态
  @observable giftOpenStatus = 0;

  //cdk活动状态
  @observable activity_status = 0;

  //cdk活动是否开启发送验证码
  @observable openSendCode = 0;

  //提交loading
  @observable submitLoading = false;

  // 下载链接配置是否已配置好
  @observable down_load_ready = false;

  /**
   * cdk弹窗
   */
  cdkModalStore = new CdkModalStore({
    KvSectionStore: this
  });

  /**
   * 成功弹窗
   */
  successModalStore = new SuccessModalStore({
    KvSectionStore: this
  });

  // 顶部左logo
  topLeftLogo = [
    {
      id: '1',
      src: require('./images/logo.png')
    }
  ];

  //左侧活动配置
  get leftActivity() {
    const activityItems = [
      {
        id: '2',
        src: require('./images/left2.png'),
        onClick: () => {
          if (this.giftOpenStatus === 2) {
            AntdMessage.error('活动已结束');
          } else {
            this.mainStore.changeMenu(3);
          }
          $$tracker.clickGoRaffle();
        }
      }
    ];

    if (this.activity_status === 1) {
      activityItems.unshift({
        id: '1',
        src: require('./images/left1.png'),
        onClick: () => {
          if (!this.activity_status) {
            AntdMessage.info('当前活动已结束');
            return;
          }
          this.modals.cdkModal.open();
          $$tracker.clickGoCdk();
        }
      });
    }

    return activityItems;
  }

  // 下载列表
  @observable
  downloadList = [
    {
      id: 'pc',
      img: require('./images/btn_pc.png'),
      hoverImg: require('./images/hov_btn_pc.png'),
      href: replaceDownloadLinkPc('https://ssglauncher.xoyocdn.com/ssglauncher/ssg/Client/prod/Channel/CBJQos/SeasunGameInstaller-CBJQos-cbjq.exe')
    },
    {
      id: 'android',
      img: require('./images/btn_Android.png'),
      hoverImg: require('./images/hov_btn_Android.png'),
      href: replaceDownloadLinkAndroid()
    },
    {
      id: 'appStore',
      img: require('./images/btn_AppStore.png'),
      hoverImg: require('./images/hov_btn_AppStore.png'),
      href: 'https://apps.apple.com/cn/app/id1606311056'
    },
    {
      id: 'tapTap',
      img: require('./images/btn_TapTap.png'),
      hoverImg: require('./images/hov_btn_TapTap.png'),
      href: 'https://www.taptap.cn/app/222089'
    }
  ];

  // 点击播放PV
  onClickPlayPv = () => {
    if (this.mainStore.drawSectionStore.activityStatus === 0) {
      AntdMessage.error('活动未开始');
      return;
    }

    if (!this.pvVideoUrl) {
      AntdMessage.info('敬请期待');
      return false;
    }

    $$tracker.clickWatchVideo();
    // 记录当前BGM状态并在需要时关闭
    if (this.mainStore && this.mainStore.bgm) {
      this.bgmWasPlayingBeforePv = !!this.mainStore.bgm.isPlaying;
      if (this.bgmWasPlayingBeforePv) {
        this.mainStore.bgm.handleChange(false);
      }
    }
    this.videoPlayState = true;

    Video.append({
      src: this.pvVideoUrl,
      onCloseCallback: () => {
        this.videoPlayState = false;
        // 仅当进入前BGM在播放时，才恢复播放
        if (this.mainStore && this.mainStore.bgm && this.bgmWasPlayingBeforePv) {
          this.mainStore.bgm.handleChange(true);
        }
        this.bgmWasPlayingBeforePv = false;
      }
    });
    this.mainStore.onExecuteMission('watchVideo');
  };

  /**
   * 隐藏预加载器背景
   */
  hideBgPreloader = () => {
    const backgroundImage = new Image();
    backgroundImage.onload = () => {
      setTimeout(() => {
        const bgPreBox = document.getElementById('bgPreBox');
        if (bgPreBox) {
          bgPreBox.style.opacity = '0';
          setTimeout(() => {
            bgPreBox.style.display = 'none';
          }, 300);
        }
      }, 100);
    };

    backgroundImage.src = require('./images/kv.jpg');
  };

  /**
   * 获取cdk
   * @param {*} phone
   * @param {*} code
   */
  getCdkCode = (phone, code) => {
    if (this.submitLoading) {
      return;
    }
    this.submitLoading = true;
    this.$ztService
      .getCdkCode({ phone, code })
      .then(res => {
        const { cdk } = res;
        this.successModalStore.cdk = cdk;
        this.cdkModalStore.onClickClose();
        this.modals.successModal.open();
      })
      .catch(err => {
        AntdMessage.error(err?.message);
      })
      .finally(() => {
        this.submitLoading = false;
      });
  };

  /**
   * 获取活动config
   */
  getActivityConfig = () => {
    this.$ztService
      .getActivityConfig()
      .then(res => {
        const { activity_status, open_send_code, text_setting } = res;
        Object.assign(this, {
          activity_status,
          openSendCode: open_send_code
        });

        this.cdkModalStore.text_setting = text_setting;
      })
      .catch(err => {
        AntdMessage.info(err?.message);
      });
  };

  use() {
    super.use();

    this.modals = {
      cdkModal: useModal(CdkModal, { store: this.cdkModalStore }),
      successModal: useModal(SuccessModal, { store: this.successModalStore })
    };

    useMount(() => {
      this.hideBgPreloader();
      this.getActivityConfig();
    });

    useEffect(
      () => {
        this.isActive = this.mainStore.pageSwiperIndex === 0;
      },
      [this.mainStore.pageSwiperIndex]
    );
  }
}

export default KvSectionStore;
